module.exports = __webpack_public_path__ + "static/media/dice-roll-1.12d71a32.gif";